import { Injectable, EventEmitter } from '@angular/core';
import {
  HttpClient,
  HttpResponse,
  HttpParams,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'underscore';
import { ResidentialService } from '../questionarie-signup/questionnaire-residential/residential.service';
import { RecommendationService } from '../questionarie-signup/questionnaire-residential/recommendation/recommendation.service';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  // API Url
  url = environment.api_url;
  hg_accountId;
  userName;
  // To emit the event on getting the response
  getUserObj = new EventEmitter();
  // For Notification flag
  setShowNotify = new EventEmitter();

  // For emit event to open notification panel
  setShowNotifyPanel = new EventEmitter();

  enrollNotificationObj;
  questionNotificationObj;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private residentialService: ResidentialService,
    private recommendationService: RecommendationService
  ) {
    this.hg_accountId = window.location.href.split('/').pop();
    this.userName = localStorage.getItem('userName');
  }
  public getHgUserObj() {
    this.hg_accountId = window.location.href.split('/').pop();
    this.userName = localStorage.getItem('userName');
    const body = new HttpParams().append('hg_accountId', this.hg_accountId);

    this.http
      .get(this.url + '/getHgUser', { params: body })
      .subscribe((res: any) => {
        const result = res;
        if (result && result.statusCode && result.statusCode === '0010') {
          return this.router.navigateByUrl('/login');
        } else {
          this.getUserObj.emit({ userObj: result });
          delete result.user.salt;
          delete result.user.schema_version;
          delete result.user.signupStatus;
          delete result.user.changePasswordStatus;
          sessionStorage.setItem('userObj', JSON.stringify(result.user));
          if (_.isEmpty(this.residentialService.user)) {
            this.residentialService.user = {
              accountId: result.user._id,
            };
          }
          this.residentialService.questionnaireStatusObj =
            result.user.questionStatusObj;
          this.residentialService.filter(result.userResponses);
          try{
            this.residentialService.currentId =
            result.user.questionStatusObj.questionStep;
          this.residentialService.messageService({
            nextId: result.user.questionStatusObj.questionStep,
            questionStatus: result.user.questionStatusObj.questionStatus,
            responses: result.userResponses,
          });

          }catch{

          }
          
          this.recommendationService.userName = result.user.userName
            ? result.user.userName
            : 'Sam';

          this.userName = !_.isEmpty(result)
            ? result.user.fName + ' ' + result.user.lName
            : 'Sam';
          return result;
        }
      });
  }
  // To set the notification show/hide flag
  setNotifyFlag(data) {
    this.setShowNotify.emit(data);
  }
  // To set the notification show/hide flag
  setNotifyPanelFlag(data) {
    this.setShowNotifyPanel.emit(data);
  }
}
